<template>
	<v-sheet style="min-height: 100%">
		<main-nav :mini="toggleMini"/>
		<v-app-bar app dark elevation="0" color="primary" height="85" clipped-left>
			<v-app-bar-nav-icon @click="toggleMini = !toggleMini">
				<v-icon color="warning" x-large>
					menu
				</v-icon>
			</v-app-bar-nav-icon>
			<v-spacer></v-spacer>
			<v-toolbar-title class="ml-4 text-h5 text-center">
				e-Boleta
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn 
						icon x-large 
						v-bind="attrs" 
						v-on="on" 
						@click="onCerrarSesionEvt" 
						class="mr-0"
						style="z-index: 6;"
					>
						<v-icon>
							power_settings_new
						</v-icon>
					</v-btn>
				</template>
				<span>Cerrar sesión</span>
			</v-tooltip>
			<template v-slot:extension>
				<empresa-selector/>
			</template>
		</v-app-bar>
		<v-main>
			<v-overlay opacity="0.75" light :value="showOverlay" z-index="5">
				<v-btn 
					x-large 
					fab
					color="siiNaranjo"
					fixed top right
					@click="cerrarSesion" 
					class="mr-0"
					style="z-index: 6;"
				>
					<v-icon>
						power_settings_new
					</v-icon>
				</v-btn>
				<div v-if="$store.getters['empresas/isLoading']">
					<p>
						Cargando Emisores...
					</p>
				</div>
				<div v-else-if="!noTieneEmisores">
					<p>
						para comenzar seleccione un emisor
					</p>
					<empresa-selector/>
				</div>
				<div v-else class="px-5">
					<p>
						<v-spacer/>
						<v-spacer/>
						Para poder utilizar e-Boleta necesitas tener al menos un EMISOR registrado, y no hemos encontrado ninguno asociado a tu usuario...
					</p>
					<v-btn @click="goToHelp">
						Presiona acá para más ayuda
					</v-btn>
				</div>
			</v-overlay>
			<v-layout>
				<v-container>
					<v-fade-transition mode="out-in" appear>
						<router-view :emisor="$store.getters['empresas/seleccionada']">
							<!-- Componente asociado a ruta -->
						</router-view>
					</v-fade-transition>
				</v-container>
			</v-layout>
		</v-main>
		<v-dialog
			v-model="displayConfirm"
			:width="$vuetify.breakpoint.lgAndUp? '33%':'auto'"
		>
			<v-card tile>
				<v-card-title class="text-center">
				<!-- <v-layout class="py-4"> -->
					<v-spacer/>
					<v-icon large color="primary">warning</v-icon>
					<v-spacer/>
				<!-- </v-layout> -->
			</v-card-title>
				<v-card-title class="text-center">
					<!-- <v-layout class=""> -->
					<v-spacer/>
					<p>¿Está seguro?</p>
					<v-spacer/>
				<!-- </v-layout> -->
				</v-card-title>
				<v-card-text>
					Confirme para cerrar sesión
				</v-card-text>
				<v-divider/>
				<v-card-actions>
					<v-btn
						color="error"
						text
						@click="displayConfirm = false"
					>
						Cancelar
					</v-btn>
					<v-spacer/>
					<v-btn
						color="success"
						tile
						@click="cerrarSesion"
					>
						Cerrar Sesión
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<check-version/>
		<Mensajeria/>
	</v-sheet>
</template>

<script>

import EmpresaSelector from '@/components/EmpresaSelector';
import MainNav from '@/components/MainNav';
import { Auth, API } from 'aws-amplify';

import CheckVersion from '@/components/CheckVersion';
import Mensajeria from '@/components/Mensajeria';

const HELP_URL = 'http://www.sii.cl/portales/boleta_electronica/index.html';

export default {
	components:{
		EmpresaSelector,
		MainNav,
		CheckVersion
		,Mensajeria
	},
	computed: {
		showOverlay () {
			return !this.$store.getters['empresas/seleccionada'] && 
				this.$store.getters['empresas/lista'].length<=0;
		},
		noTieneEmisores(){
			return this.$store.getters['empresas/lista'].length<=0;
		}
	},
	data() {
		return {
			emisor: undefined,
			toggleMini: false,
			displayConfirm: false,
			helpUrl: HELP_URL,
			unsubscribe: undefined
		};
	},
	methods: {
		onCerrarSesionEvt: function(evt){
			this.displayConfirm = true;
		},
		cerrarSesion: async function() {
			let vm = this;

			let signout = await vm.$store.dispatch('usuario/signOut')


			if( !signout )
				vm.$router.push({name: 'inicio'});
		},
		goToHelp: function(){
			// TODO descomentar esta linea en caso de que SII comparta la url
			// para redireccionar. UTILIZAR LA CONSTANTE "HELP_URL"
			window.location.replace(this.helpUrl);
		},
	},
	mounted: function() {
		let vm = this;

  	vm.$store.dispatch('empresas/getEmpresas');
		vm.$store.dispatch('app/getConfig')
	},
	watch: {
		emisores: function(nuevosEmisores) {
			let vm = this;
			if(nuevosEmisores.length > 0) {
				// EGILTODO elegir emisor desde sesión (?)
				vm.emisor = nuevosEmisores[0];
			}
		}
	},
};
</script>
